import { render, staticRenderFns } from "./cancelAppointItem.vue?vue&type=template&id=46b7144f&"
import script from "./cancelAppointItem.vue?vue&type=script&lang=js&"
export * from "./cancelAppointItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports